import React, { Fragment, useState } from "react";
import ComponentCard from "../../../../Cards/ComponentCard/ComponentCard";
import PinInputAdd from "../../../PinInput/InputPinV2/Input/PinInput-Add";
import OutputAdd from "../OutPut/OutputPin-Add";
import PinOutput from "../OutPut/PinOutput"
import PinOutputPulse from "../OutPut/PinOutputPulse";
import PinOutputPulseSocket from "../OutPut/PinOutputPulseSocket";
import { getLinkedIntegrationIcon } from "../OutPut/integrationIcons";

import classes from "./PinOutputList.module.css";

const PinOutputList = ({ OutputPins, polarity, SmartLocks, firmware, holidayModeActive, pinIntegrations, schedules, todaysSchedules, setHasDeviceChanged }) => {

    const pinNameMap = OutputPins.reduce((map, pin) => {
        map[String(pin.Pin)] = pin.pinName;
        return map;
    }, {});

    console.log("mapp", pinNameMap);

    return (
        <ComponentCard id="OutPutPinListCard" className={classes["pin-switches"]}>
            {OutputPins.map((outPutPin, index) => {
                const SmartLock = SmartLocks.find(Lock => Lock.outputPin == outPutPin.Pin);
                const isActive = outPutPin.active == 1
                const linkedIntegrationIcon = getLinkedIntegrationIcon(pinIntegrations, outPutPin.Pin);
                const pinSchedules = schedules?.filter(s => s.pin?.includes(String(outPutPin.Pin)) && s.active) || [];
                const pinTodaysSchedules = todaysSchedules?.filter(s => String(s.pin) === String(outPutPin.Pin)) || [];
                console.log(isActive);
                console.log(outPutPin);
                return (
                    isActive && (
                    outPutPin.type == "LATCH" || outPutPin.type == "VIRTUAL_LATCH" ? <PinOutput key={index} OutPutPin={outPutPin} polarity={polarity} SmartLock={SmartLock != undefined ? SmartLock : null} firmware={firmware} holidayModeActive={holidayModeActive} linkedIntegrationIcon={linkedIntegrationIcon} schedules={pinSchedules} pinNameMap={pinNameMap} todaysSchedules={pinTodaysSchedules} setHasDeviceChanged={setHasDeviceChanged} /> :
                        <PinOutputPulseSocket key={index} OutPutPin={outPutPin} SmartLock={SmartLock != undefined ? SmartLock : null} holidayModeActive={holidayModeActive} linkedIntegrationIcon={linkedIntegrationIcon} schedules={pinSchedules} todaysSchedules={pinTodaysSchedules} setHasDeviceChanged={setHasDeviceChanged} />
                ) )
            })}
        </ComponentCard>
    )

}

export default PinOutputList;